import React from 'react'
import { IMediaCard } from '@pcln/contentful-components'
import MediaCardComponent from '@/components/Promos/MediaCard/MediaCardComponent'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import CONTENT from './content'

export default function PriceBreakers() {
  const promo = useContentfulVariation<IMediaCard>('leftPromoBox')
  const hasContentfulData = promo != null
  const mediaCardContent = hasContentfulData ? promo : CONTENT

  return <MediaCardComponent content={mediaCardContent} />
}
